import { Controller } from "@hotwired/stimulus"

// Stops Enter pressed inside a single-line text field from implicitly submitting
// the form. Textareas keep Enter for newlines, and the submit button keeps Enter
// for explicit submission — only the accidental input->submit is blocked.
//
// Attach to a <form> and route Enter to it:
//   data-controller="prevent-enter-submit"
//   data-action="keydown.enter->prevent-enter-submit#preventSubmit"
export default class extends Controller {
  preventSubmit(event) {
    const target = event.target
    if (target.tagName !== "INPUT") return
    if (target.type === "submit" || target.type === "button") return

    event.preventDefault()
  }
}
